import moment from "moment";
import React, { useState, Component } from "react";
import Slider from "react-slick";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Popover from "@material-ui/core/Popover";
import { Typography } from "@material-ui/core";
import "./index.css";
import axios from "axios";

class DesignItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEls: {},
    };
  }
  setAnchorEls = (target) => {
    this.setState({ anchorEls: target });
  };
  render() {
    var settings = {
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    var settings1 = {
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      mobileFirst: true,
    };

    const array = ["Kp", "En", "Cn", "Ru"];

    const { design, language, search, firstPage } = this.props;
    const {
      categoryLabel,
      designNameLabel,
      rDateLabel,
      rNumberLabel,
      rOrgLabel,
      newLabel,
    } = this.props.labels;

    const newDate = moment(design.createdAt)
      .add(7, "days")
      .format("YYYY-MM-DD");
    const today = moment().format("YYYY-MM-DD");

    const markHighLight = (str, keyword) => {
      const patt = new RegExp(keyword, "g");
      if (str != "" && str !== null && str !== undefined && keyword !== "") {
        return str.replace(patt, `<mark>${keyword}</mark>`);
      } else if (keyword !== "" && (str === null || str === undefined)) {
        return "";
      } else if (keyword === "" && (str === null || str === undefined)) {
        return "";
      } else if (keyword === "") {
        return str;
      }
    };

    const handlePopoverOpen = (event, name) => {
      let temp = {};
      temp[name] = event.currentTarget;
      this.setAnchorEls(temp);
    };

    const handlePopoverClose = (key) => {
      let temp = { ...this.anchorEls };
      temp[key] = null;
      this.setAnchorEls(temp);
    };

    const propertyArray = ["title", "kind", "owner", "regNo", "regDate"];

    return (
      <>
        <div
          className="design-item bg-light m-1 position-relative"
          style={{
            width: "300px",
            border: "1px solid rgba(0,0,0,0.3)",
            borderRadius: "4px",
            marginTop: "32px",
          }}
        >
          {today <= newDate && (
            <div className="item-new-label">{newLabel[language]}</div>
          )}

          {propertyArray.map((key, index) => {
            let languageSuffix = array[language];

            return (
              <Popover
                key={key}
                style={{ pointerEvents: "none", padding: 8 }}
                open={Boolean(this.state.anchorEls[key])}
                anchorEl={this.state.anchorEls[key]}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                onClose={() => handlePopoverClose(key)}
                disableRestoreFocus
              >
                <Typography
                  style={{ width: 350, hight: 400 }}
                  dangerouslySetInnerHTML={{
                    __html:
                      key != "regNo" && key != "regDate"
                        ? `${design[`${key}${languageSuffix}`]}`
                        : key != "regDate"
                        ? `${design[`${key}`]}`
                        : `${moment(design[key]).format("YYYY-MM-DD")}`,
                  }}
                ></Typography>
              </Popover>
            );
          })}

          <div
            style={{
              borderBottom: "1px solid rgba(0, 123,255, 0.3)",
              cursor: "pointer",
            }}
          >
            <Slider
              {...settings}
              // onClick={
            >
              {design.imageUrls.map((imageUrl, index) => (
                <img
                  key={index}
                  data-toggle="modal"
                  data-target={`#myModal_${design.titleKp}`}
                  className="w-100"
                  src={`uploads/design/${imageUrl}`}
                  alt={imageUrl}
                  onClick={() =>
                    axios
                      .post(`/api/log`, {
                        title: design.titleKp,
                        lang: array[language],
                        type: "화상",
                      })
                      .then((res) => {
                        // setMarks(res.data);
                        // console.log(res.data);
                      })
                      .catch()
                  }
                />
              ))}
            </Slider>
          </div>
          {!firstPage && (
            <div className="p-3 h6">
              <div
                className="pb-2 font-weight-bold design-value-ellipsis"
                onMouseEnter={(event) => handlePopoverOpen(event, "title")}
                onMouseLeave={(event) => handlePopoverClose(event, "title")}
              >
                <b>{designNameLabel[language]}</b> : &nbsp;
                <span
                  className="design-name"
                  dangerouslySetInnerHTML={{
                    __html: markHighLight(
                      design[`title${array[language]}`],
                      search
                    ),
                  }}
                ></span>
              </div>
              <div
                className="h6 design-value-ellipsis"
                onMouseEnter={(event) => handlePopoverOpen(event, "kind")}
                onMouseLeave={(event) => handlePopoverClose(event, "kind")}
              >
                <b>{categoryLabel[language]}</b> :{" "}
                <span
                  className="design-attribute"
                  dangerouslySetInnerHTML={{
                    __html:
                      design[`kind${array[language]}`] &&
                      design[`kind${array[language]}`].length >= 10
                        ? design[`kind${array[language]}`].slice(0, 10)
                        : design[`kind${array[language]}`],
                  }}
                ></span>
              </div>
              <div
                className="h6 design-value-ellipsis"
                onMouseEnter={(event) => handlePopoverOpen(event, "owner")}
                onMouseLeave={(event) => handlePopoverClose(event, "owner")}
              >
                <b>{rOrgLabel[language]}</b> :{" "}
                <span
                  className="design-attribute"
                  dangerouslySetInnerHTML={{
                    __html: markHighLight(
                      design[`owner${array[language]}`],
                      search
                    ),
                  }}
                ></span>
              </div>
              <div
                className="h6 design-value-ellipsis"
                onMouseEnter={(event) => handlePopoverOpen(event, "regNo")}
                onMouseLeave={(event) => handlePopoverClose(event, "regNo")}
              >
                <b>{rNumberLabel[language]}</b> :{" "}
                <span
                  className="design-attribute"
                  dangerouslySetInnerHTML={{
                    __html: markHighLight(design.regNo, search),
                  }}
                ></span>
              </div>
              <div
                className="h6 design-value-ellipsis"
                onMouseEnter={(event) => handlePopoverOpen(event, "regDate")}
                onMouseLeave={(event) => handlePopoverClose(event, "regDate")}
              >
                <b>{rDateLabel[language]}</b> :{" "}
                <span className="design-attribute">
                  {moment(design.regDate).format("YYYY-MM-DD")}
                </span>
              </div>
            </div>
          )}
        </div>
        <div className="modal fade" id={`myModal_${design.titleKp}`}>
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <div className="h5 font-weight-bold">
                  <b>{designNameLabel[language]}</b> :{" "}
                  <span className="mark-name">
                    {design[`title${array[language]}`]}
                  </span>
                </div>
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>

              <div className="modal-body" style={{ textAlign: "center" }}>
                <Slider {...settings1}>
                  {design.imageUrls.map((url, index) => (
                    <img
                      className="h-100"
                      style={{ width: 500, textAlign: "center" }}
                      key={index}
                      src={`uploads/design/${url}`}
                      alt="dprk intellectual property association"
                    />
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

DesignItem.propTypes = {
  design: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  language: state.profile.language,
  labels: state.labels,
  search: state.profile.search,
});

export default connect(mapStateToProps)(DesignItem);
